export default "__VITE_ASSET__DH7JpsDO__"